
<div *ngIf="isSearch">
  <div fxLayoutAlign="center">
    <h1 style="margin-top: 20px;">Workers' Compensation Exemption Registration Search
    </h1>
  </div>
  <div fxLayoutAlign="center">
    <h3>At least one field must be entered to search. File or Amended between dates require both
      to search.
    </h3>
  </div>
  <mat-card class="container" style="margin-top:10px; max-width: 900px;">
    <mat-card-content>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-form-field class="">
            <mat-label>Registration Control #</mat-label>
            <input matInput placeholder="Registration Control" [(ngModel)]="RegistriationControlNumber" value="">
          </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12" style="text-align: right;">
          <mat-form-field class="">
            <mat-label>FEIN</mat-label>
            <input matInput placeholder="FEIN" [(ngModel)]="FEIN" value="">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-form-field class="standardWidth">
            <mat-label>First Name</mat-label>
            <input matInput placeholder="First Name" [(ngModel)]="FirstName" value="">
          </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-radio-group [(ngModel)]="FirstNameSearchType">
            <mat-radio-button value="1">Starts With</mat-radio-button>
            <mat-radio-button value="2">Contains</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-form-field class="standardWidth">
            <mat-label>Middle Name</mat-label>
            <input matInput placeholder="Middle Name" [(ngModel)]="MiddleName" value="">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-form-field class="standardWidth">
            <mat-label>Last Name</mat-label>
            <input matInput placeholder="Last Name" [(ngModel)]="LastName" value="">
          </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-radio-group [(ngModel)]="LastNameSearchType">
            <mat-radio-button value="1">Starts With</mat-radio-button>
            <mat-radio-button value="2">Contains</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-form-field class="standardWidth">
            <mat-label>Business Entity Name</mat-label>
            <input matInput placeholder="Business Entity Name" [(ngModel)]="BusinessEntityName" value="">
          </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-radio-group [(ngModel)]="BusinessEntityNameSearchType">
            <mat-radio-button value="1">Starts With</mat-radio-button>
            <mat-radio-button value="2">Contains</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-form-field class="standardWidth">
            <mat-label>Business Entity Control</mat-label>
            <input matInput placeholder="Business Entity Control" value="" [(ngModel)]="BusinessControllNumber">
          </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-form-field class="standardWidth">
            <mat-label>State License #</mat-label>
            <input matInput placeholder="State License #" value="" [(ngModel)]="StateLicenseNumber">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select [(ngModel)]="Status">
              <mat-option *ngFor="let rl of StatusTypes" [value]="rl.id">
                {{rl.description}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- <div class="col-lg-6 col-md-6 col-sm-12">

      </div> -->
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-form-field>
            <input matInput [matDatepicker]="FilingDateFrom1" placeholder="File or Amended Between"
              [(ngModel)]="FilingDateFrom">
            <mat-datepicker-toggle matSuffix [for]="FilingDateFrom1"></mat-datepicker-toggle>
            <mat-datepicker #FilingDateFrom1></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-form-field>
            <input matInput [matDatepicker]="FilingDateTo1" placeholder="And" [(ngModel)]="FilingDateTo">
            <mat-datepicker-toggle matSuffix [for]="FilingDateTo1"></mat-datepicker-toggle>
            <mat-datepicker #FilingDateTo1></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <form [formGroup]="form">
        <div class="row">
          
          <div class="col-lg-6 col-md-6 col-sm-12">
            <label for="g-recaptcha-response" style="display:none">Please confirm you are not a robot:</label>
            <re-captcha formControlName="recaptcha"aria-label="Please confirm you are not a robot"  id="recaptcha" name="recaptcha" formControlName="recaptcha" aria-label="reCAPTCHA verification"
              required>
            </re-captcha>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <button [disabled]="!form.valid" mat-raised-button color="primary" (click)="onSearch()">Search</button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <div>
    <div style="margin:30px; margin-bottom: 150px;">
      <div fxLayout="row" fxLayoutAlign="end center">
        <mat-form-field style="max-width: 150px;">
          <mat-label>Per Page</mat-label>
          <mat-select [(ngModel)]="pageSize" (selectionChange)="pageSizeChanged()">
            <mat-option *ngFor="let rl of pageSizeOptions" [value]="rl">
              {{rl}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="standard" sty="max-width:600px" fxLayout="row" fxLayoutAlign="end">
          <mat-label>Search</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
        </mat-form-field>
      </div>
      <table mat-table matTableExporter [dataSource]="dataSource" matSort #exporter="matTableExporter"
        class="mat-elevation-z8">
        <ng-container matColumnDef="registrationControlNumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Reg Control # </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span  *ngIf="element.exemptionFilingId == null">{{element.registrationControlNumber}}</span>
            <a *ngIf="element.exemptionFilingId != null" class="registrationLink"
              (click)="navigateToExemption(element.exemptionFilingId)">{{element.registrationControlNumber}}</a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="formattedName">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Applicant Name </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.formattedName }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="filingDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Effective Date</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.filingDate | date: 'MM/dd/yyyy'}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="externalStatusName">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.externalStatusName}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="filingEntityName">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Business Entity </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.filingEntityName}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="physicalAddress">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Physical Address </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.physicalAddress}}</mat-cell>
        </ng-container>
        <tr class="mat-row" *matNoDataRow>
          <td *ngIf="isSearching" class="mat-cell">No records found</td>
        </tr>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </table>
      <div *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center; background: white;">
        <mat-progress-spinner color="primary" mode="indeterminate">
        </mat-progress-spinner>
      </div>
      <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize" [showFirstLastButtons]="true" 
        [pageSizeOptions]="pageSizeOptions" hidePageSize="true" (page)="pageChanged($event)" aria-label="Select page">
      </mat-paginator>
    </div>
  </div>
</div>
<div *ngIf="!isSearch">
  <app-registration-details (retunToSearch)="isSearch=true" [historyData]="historyData" [exemptionData]="exemptionData"></app-registration-details>
</div>